function initialFeedbackValue() {
  return {
    type: 'ul',
    children: [
      {
        type: 'li',
        children: [
          {
            type: 'p',
            children: [
              {
                text: '',
                marks: [],
              },
            ],
          },
        ],
      },
    ],
  };
}

export const feedbackTransforms = {
  initialFeedbackValue,
};
